import { Building } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";

const NonprofitFormation = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Non-Profit Organization Formation</h2>
          <p className="text-lg text-muted-foreground">
            Complete 501(c)(3) formation and tax-exempt status applications for Texas non-profit organizations. We handle incorporation, IRS applications, bylaws, and ongoing compliance to establish your charitable mission.
          </p>
        </div>
      </div>
    </section>
  );
  return <GenericPracticePage title="Non-Profit Formation" subtitle="Establish Your Charitable Organization" icon={<Building className="h-16 w-16" />} mainContent={mainContent} />;
};
export default NonprofitFormation;